import { z } from 'zod'

import { FORM_MESSAGES_MAP } from '@/constants/formMessages.constants'

export const goalRecommendationSchema = z.object({
  amount: z.number().min(0).optional(),
  dueDate: z
    .string({ required_error: FORM_MESSAGES_MAP.REQUIRED })
    .min(1, FORM_MESSAGES_MAP.REQUIRED),
  name: z
    .string({ required_error: FORM_MESSAGES_MAP.REQUIRED })
    .min(1, FORM_MESSAGES_MAP.REQUIRED),
})
